const CHART_TEXT_STYLE = {
  fontSize: 12,
  color: '#B88B3A',
};

const CHART_AREA = {
  left: 60,
  right: 20,
  height: '75%',
};

const TOOLTIP_COLUMN = {
  type: 'string',
  role: 'tooltip',
  p: { html: true },
};

const BASE_CHART_OPTIONS = {
  backgroundColor: 'transparent',
  height: 400,
  legend: { position: 'none' },
  chartArea: CHART_AREA,
  tooltip: { isHtml: true },
  hAxis: {
    textStyle: CHART_TEXT_STYLE,
  },
};

export const comparisonChartColumns = [
  { type: 'string', label: 'Período' },
  { type: 'number', label: 'Faturamento' },
  TOOLTIP_COLUMN,
];

export const comparisonChartOptions = {
  ...BASE_CHART_OPTIONS,

  width: '100%',
  colors: ['#D5B96F'],

  bar: {
    groupWidth: '25%',
  },

  vAxis: {
    format: 'R$ #,##0.00',
    textStyle: CHART_TEXT_STYLE,
  },
};

export const salesEvolutionColumns = [
  { type: 'string', label: 'Período' },
  { type: 'number', label: 'Faturamento' },
  TOOLTIP_COLUMN,
  { type: 'number', label: 'Quantidade de vendas' },
  TOOLTIP_COLUMN,
];

export const salesEvolutionOptions = {
  ...BASE_CHART_OPTIONS,

  colors: ['#D5B96F', '#B88B3A'],

  pointSize: 6,
  lineWidth: 2,

  vAxes: {
    0: {
      format: 'currency',

      viewWindow: {
        min: 0,
      },

      gridlines: {
        color: '#d9d9d9',
      },

      minorGridlines: {
        count: 1,
        color: '#eeeeee',
      },

      textStyle: CHART_TEXT_STYLE,
    },

    1: {
      format: '0',

      viewWindow: {
        min: 0,
      },

      gridlines: {
        color: 'transparent',
      },

      minorGridlines: {
        count: 0,
        color: 'transparent',
      },

      textStyle: CHART_TEXT_STYLE,
    },
  },

  series: {
    0: { targetAxisIndex: 0 },
    1: { targetAxisIndex: 1 },
  },
};
